<ng-container appFullContent bodyClass="body-auth">
  <div class="card-container">
    <div class="left-panel-container d-none d-md-block">
      <app-left-panel></app-left-panel>
    </div>
    <div class="right-panel-container">
      <div class="mobile-logo d-md-none text-center mb-4">
        <img src="/assets/brand/hivve-azure.png" alt="Logo" />
      </div>
      <router-outlet></router-outlet>
      <div class="mobile-footer text-center mt-4 d-md-none">
        <div class="mb-0 text-center">
          <app-legal-links></app-legal-links>
          <app-copyright></app-copyright>
        </div>
      </div>
    </div>
  </div>
</ng-container>
